import request from '@/services/request'
import { getApiUrl, getEventApiUrl } from '@/utils/tool'

export function getEvent(object) {
  return request({
    cache: {
      // maxAge: 15 * 60 * 1000,
      key: req => {
        return req.url + JSON.stringify(object)
      }
      // exclude: {
      //   methods: ['put', 'patch', 'delete']
      // }
    },
    baseURL: getApiUrl(),
    url: '/event/get-event',
    method: 'post',
    data: object,
    customConfig: {
      mute: true,
      noLoading: true
    }
  })
}

export function getEventDetail(event_id) {
  return request({
    cache: {
      // maxAge: 15 * 60 * 1000,
      key: req => {
        return req.url + event_id
      }
      // exclude: {
      //   methods: ['put', 'patch', 'delete']
      // }
    },
    baseURL: getApiUrl(),
    url: '/event/get-event-detail',
    method: 'post',
    data: { event_id: event_id },
    customConfig: {
      noLoading: true
    }
  })
}

export function joinEvent(event_id) {
  return request({
    baseURL: getApiUrl(),
    url: '/event/join-event',
    method: 'post',
    data: { event_id: event_id }
  })
}

export function joinEventV2(data) {
  return request({
    baseURL: getApiUrl(),
    url: '/event/join-event-v2',
    method: 'post',
    data: data
  })
}
export function joinEventV3(event_id) {
  return request({
    baseURL: getApiUrl(),
    url: '/event/join-event-v3',
    method: 'post',
    data: { event_id: event_id },
    customConfig: {
      noLoading: true
    }
  })
}

export function getEventTask() {
  return request({
    baseURL: getApiUrl(),
    url: '/event/get-task',
    method: 'post'
  })
}

export function getMemberTask(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/event/get-member-task',
    method: 'post',
    data: object
  })
}

export function receive(event_member_id) {
  return request({
    baseURL: getApiUrl(),
    url: '/event/receive',
    method: 'post',
    data: { event_member_id: event_member_id }
  })
}
export function receiveV2(event_member_id) {
  return request({
    baseURL: getApiUrl(),
    url: '/event/receive-v2',
    method: 'post',
    data: { event_member_id: event_member_id }
  })
}

export function getPromoteReward(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/event/get-promote-reward',
    method: 'post',
    data: object
  })
}
export function getFriendTask(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/event/get-friend-task',
    method: 'post',
    data: object
  })
}
export const getEventQualification = (event_type, prize_rate, amount, time) =>
  request({
    baseURL: getApiUrl(),
    url: '/event/qualification',
    method: 'post',
    data: { event_type, prize_rate, amount, time }
  })

let brandCode = process.env.VUE_APP_BRAND_CODE // 開發環境指定brand code
if (brandCode === '') {
  brandCode = window.location.host || document.location.host // 剛開始載入先用host取資訊
}

// 錦標賽
export function getBetRankList() {
  return request({
    baseURL: getEventApiUrl(),
    url: `/betRanking/list/bet_ranking?code=${brandCode}`,
    method: 'get'
  })
}

export function getPrizes(object) {
  return request({
    baseURL: getEventApiUrl(),
    url: `/betRanking/${object.event_id}?updatesSeconds=1200`,
    method: 'post',
    data: object
  })
}
export function getProxyEmail(urlAddress) {
  return request({
    url: `${urlAddress}`,
    method: 'get'
  })
}
